import { instance, errorService } from '@/services/api'
import { masterAPIs, dropdownAPIs, screenType } from '@/services/authConstantsV1'
import { calculateGridHeight, showNotification, customComparator } from '@/services/calculate'
import { gridProperties } from '@/services/column.config'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import Pagination from '@/components/DynamicComponents/Pagination'
import exportTemplates from '@/components/DynamicComponents/exportTemplates'
import importTemplates from '@/components/DynamicComponents/importTemplates'
import ContractComponent from '@/components/DynamicComponents/Admin/MasterData/Contract'
import { tableName } from '@/services/config'

export default {
  components: {
    importTemplates,
    exportTemplates,
    'ag-grid-vue': AgGridVue,
    Pagination,
    ContractComponent,
  },
  props: {
    tabKey: String,
    type: String,
    role: String,
    screenId: Number,
    columnSettings: Array,
  },
  data: function () {
    const checTextkLength = (rule, value, callback) => {
      if (rule.field === 'notes') {
        if (String(value).length > 200) {
          callback(
            new Error('Notes must be less than or equals to 100 characters'),
          )
        } else {
          callback()
        }
      } else if (rule.field === 'category_Code') {
        if (String(value).length > 6) {
          callback(
            new Error('Category code must be less than or equals to 6 digits'),
          )
        } else {
          callback()
        }
      } else {
        let field = 'Contract name'
        if (rule.field === 'description') {
          field = 'Description'
        }
        if (String(value).length > 100) {
          callback(
            new Error(field + ' must be less than or equals to 100 characters'),
          )
        } else {
          callback()
        }
      }
    }
    return {
      exportClicked: false,
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 10px',
      },
      count: 0,
      loading: true,
      spinner: false,
      defaultSortedBy: 'categoryCode',
      defaultSortOrder: true,
      page: 0,
      pageSize: 0,
      propertyUnitList: [],
      visible: false,
      modalTitle: '',
      form: {
        id: undefined,
        category_Code: undefined,
        eligible: false,
        asset_Class: undefined,
        asset_Class_Id: undefined,
        master_Asset_Class_Id: undefined,
        BSUOP_Details_Id: undefined,
        master_BSUOP_Details_Id: undefined,
        description: undefined,
        notes: undefined,
        keywords: undefined,
        keywordList: [],
        isActive: 1,
        contract_Details_Id: undefined,
        master_Contract_Details_Id: undefined,
        contract: undefined,
        bsuop_Name: undefined,
        asset_Class_Name: undefined,
      },
      rules: {
        contract: [
          {
            required: true,
            message: 'Please select contract',
            trigger: 'change',
          },
        ],
        category_Code: [
          {
            required: true,
            message: 'Please enter category code',
            trigger: 'blur',
          },
          { validator: checTextkLength, trigger: 'blur' },
        ],
        asset_Class_Name: [
          {
            required: true,
            message: 'Please select asset class',
            trigger: 'change',
          },
        ],
        bsuop_Name: [
          { required: true, message: 'Please select bsuop', trigger: 'change' },
        ],
        description: [
          {
            required: true,
            message: 'Please enter description',
            trigger: 'blur',
          },
          { validator: checTextkLength, trigger: 'blur' },
        ],
      },
      assetClassList: [],
      selectedRowKeys: [],
      loadRefresh: false,
      // gridOptions: null,
      // columnDefs: [],
      frameworkComponents: null,
      tableParams: null,
      width: '100%',
      height: '400px',
      uploadedFile: null,
      importClicked: false,
      importColDef: gridProperties.import.columns.categoryCode,
      loadImport: false,
      filters: {},
      bsuopList: [],
      contractList: [],
      isAddContract: false,
      tableState: null,
      gridOptions: {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        rowSelection: 'multiple',
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          comparator: customComparator,
          resizable: true,
          menuTabs: ['filterMenuTab'],
          filterParams: {
            buttons: ['apply'],
            newRowsAction: 'keep',
          },
        },
      },
      columnDefs: gridProperties.master.columns.categoryCode,
    }
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.pageSize = settings.application.defaultRecord
    this.loadingConfig()
    if (this.role === 'Admin') {
      this.getAssetClasses()
      this.getBSUOP()
      this.getContract()
    }
  },
  mounted() {
    this.$root.$on('deleteCategoryCode', this.deleteCategoryCode)
    this.$root.$on('editCategoryCode', this.getCategoryCodeById)
    window.addEventListener('resize', this.getWindowSize)
  },
  beforeDestroy() {
    this.$root.$off('deleteCategoryCode')
    this.$root.$off('editCategoryCode')
    this.$off('updateTableData')
    window.removeEventListener('resize', this.getWindowSize)
  },
  watch: {
    tabKey() {
      if (this.tabKey === '8') {
        this.filters = {}
        const data = this.gridOptions.api.getFilterModel()
        Object.keys(data).forEach(element => {
          const filterComponent = this.gridOptions.api.getFilterInstance(
            element,
          )
          filterComponent.setModel(null)
        })
        this.propertyUnitList = []
        this.loading = true
        this.getAssetClasses()
        this.getBSUOP()
        this.getContract()
        this.getColumnSettings(this.gridOptions)
      }
    },
  },
  methods: {
    loadingConfig() {
      this.frameworkComponents = gridProperties.master.frameworks
      this.gridOptions.isRowSelectable = node => {
        if (node.data) {
          if (node.data.isLinked || node.data.applicationId) return false
          else return true
        }
      }
      gridProperties.master.columns.categoryCode.map(i => {
        if (i.field === 'action' || i.field === 'isActive' || !i.field) {
          i.hide = this.type === 'Template'
        }
      })
    },

    // Refresh Category Codes
    refreshCategoryCodes() {
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = this.gridOptions.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      this.loading = true
      this.loadRefresh = true
      this.propertyUnitList = []
      this.page = 0
      this.defaultSortedBy = 'categoryCode'
      this.defaultSortOrder = true
      this.selectedRowKeys = []
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'categoryCode',
            sort: 'asc',
          },
        ],
        defaultState: { sort: null },
      })
      this.gridOptions.api.destroyFilter()
      this.filters = {}
      this.getCategoryCodes(this.gridOptions)
    },

    // Close the dialog
    handleCancel() {
      this.visible = false
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Add New Category Code
    addNew() {
      this.visible = true
      this.modalTitle = 'Add New Category Code'
      this.form.id = undefined
      this.form.keywordList = []
      this.isActive = 1
      this.form.contract_Details_Id = undefined
      this.form.BSUOP_Details_Id = undefined
      this.form.asset_Class_Id = undefined
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Delete Category Code
    deleteCategoryCode(data) {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete '${data.categoryCode}' ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to this category
              code
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(data)
        },
        onCancel() { },
        class: 'test',
      })
    },

    // Save Category Code
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.spinner = true
          this.form.keywords = this.form.keywordList.join(',')
          let url
          let method = 'put'
          const req = {
            assetClassId: this.form.asset_Class_Id,
            contractId: this.form.contract_Details_Id,
            bsuopId: this.form.BSUOP_Details_Id,
            categoryCode: this.form.category_Code,
            description: this.form.description,
            eligible: this.form.eligible,
            notes: this.form.notes,
            keywords: this.form.keywords,
          }
          if (this.form.id) {
            url = masterAPIs.categoryCode.details(this.form.id)
            method = 'patch'
          } else {
            url = masterAPIs.categoryCode.add
            method = 'post'
          }
          instance[method](url, req)
            .then(response => {
              this.spinner = false
              this.visible = false
              showNotification(
                'success',
                this.form.id
                  ? 'Update Category Code'
                  : 'Create Category Code',
                this.form.id
                  ? 'Category Code updated successfully!'
                  : 'Category Code created successfully!',
              )
              if (this.form.id) {
                const newData = [...this.propertyUnitList]
                const index = newData.findIndex(i => i.id === this.form.id)
                newData[index] = _.get(response.data, 'result', null)
                this.propertyUnitList = newData
              } else {
                this.getCategoryCodes(this.tableParams)
              }
              this.$refs.ruleForm.resetFields()
            })
            .catch(error => {
              this.spinner = false
              errorService(error)
            })
        }
      })
    },

    // Get Category Codes
    getCategoryCodes(params, type) {
      const req = {
        pageSize: this.pageSize,
        currentPage: this.page,
        sortColumn: this.defaultSortedBy,
        isAscending: this.defaultSortOrder,
        contract: _.get(this.filters, 'contract', undefined),
        contractName: _.get(this.filters, 'contractName', undefined),
        categoryCode: _.get(this.filters, 'categoryCode', undefined),
        description: _.get(this.filters, 'description', undefined),
        assetClass: _.get(this.filters, 'assetClass', undefined),
        BSUOP: _.get(this.filters, 'bsuop', undefined),
        BSUOPDescription: _.get(this.filters, 'bsuopDescription', undefined),
        keywords: _.get(this.filters, 'keywords', undefined),
      }
      instance
        .post(masterAPIs.categoryCode.list, req)
        .then(response => {
          this.tableParams = null
          this.tableParams = params
          this.propertyUnitList = _.get(response.data, 'result', [])
          this.count = _.get(response.data, 'totalCount', 0)
          this.height = calculateGridHeight(
            'proprtyUnitTable',
            this.count > this.pageSize,
          )
          this.loading = false
          this.loadRefresh = false
          if (type === 'sort') {
            this.updateColumnSettings()
          }
        })
        .catch(error => {
          this.loading = false
          this.loadRefresh = false
          errorService(error)
        })
    },

    // Get Category Codes
    getCategoryCodeById(id) {
      this.modalTitle = 'Edit'
      this.visible = true
      this.spinner = true
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
      instance
        .get(masterAPIs.categoryCode.details(id))
        .then(response => {
          this.form.id = _.get(response.data, 'result.id', undefined)
          this.form.description = _.get(
            response.data,
            'result.description',
            undefined,
          )
          this.form.notes = _.get(response.data, 'result.notes', null)
          this.form.isActive = _.get(response.data, 'result.isActive', 0)
          this.form.eligible = _.get(response.data, 'result.eligible', false)
          this.form.asset_Class = _.get(
            response.data,
            'result.assetClass',
            undefined,
          )
          this.form.asset_Class_Id = _.get(
            response.data,
            'result.assetClassId',
            undefined,
          )
          this.form.BSUOP_Details_Id = _.get(
            response.data,
            'result.bsuopDetailsId',
            undefined,
          )
          this.form.category_Code = _.get(
            response.data,
            'result.categoryCode',
            undefined,
          )
          this.form.contract_Details_Id = _.get(
            response.data,
            'result.contractDetailsId',
            undefined,
          )
          this.form.bsuop_Name = `${Number(
            _.get(response.data, 'result.bsuop', undefined),
          )} - ${_.get(response.data, 'result.bsuopDescription', undefined)}`
          this.form.asset_Class_Name = `${this.assetClassList.find(i => i.id === this.form.asset_Class_Id)
            .value}`
          this.form.contract = `${Number(
            _.get(response.data, 'result.contract', undefined),
          )} - ${_.get(response.data, 'result.contractName', undefined)}`
          if (response.data.result.keywords) {
            this.form.keywordList = _.get(
              response.data,
              'result.keywords',
              [],
            ).split(',')
          } else {
            this.form.keywordList = []
          }
          this.spinner = false
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    confirmDelete(record) {
      this.loading = true
      const ids = record ? [record.id] : this.selectedRowKeys
      instance
        .patch(masterAPIs.categoryCode.delete, ids)
        .then(response => {
          showNotification(
            'success',
            'Delete Category Code',
            'Category Code deleted successfully!',
          )
          this.refreshCategoryCodes()
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    // Add Keywords
    addKeywords($event) {
      if ($event.target.value && $event.target.value.trim()) {
        const present = this.form.keywordList.find(
          i => i.toLowerCase() === $event.target.value.toLowerCase(),
        )
        if (!present) {
          this.form.keywordList.push($event.target.value)
        }
        this.form.keyword = null
      } else {
        this.form.keyword = null
      }
    },

    // Remove Keywords
    removeKeywords(index) {
      this.form.keywordList.splice(index, 1)
    },

    // Asset Class List
    getAssetClasses() {
      const url = dropdownAPIs.dropdown
      const method = 'post'
      instance[method](url, { asset_class: 0 })
        .then(response => {
          this.assetClassList = []
          const list = _.get(response.data, 'result.asset_Class', [])
          list.forEach(element => {
            element.name = `${element.option} - ${element.value}`
            this.assetClassList.push(element)
          })
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    onChange(checked) {
      this.form.eligible = checked
    },

    // exportClicked
    downloadTemplate() {
      this.exportClicked = true
    },

    clickedCancel() {
      this.exportClicked = false
    },

    // Delete All Category Codes
    deleteAllType() {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected property units ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to selected
              category codes
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete()
        },
        onCancel() { },
        class: 'test',
      })
    },

    checkboxSelection(params) {
      return params.columnApi.getRowGroupColumns().length === 0
    },

    headerCheckboxSelection(params) {
      return params.columnApi.getRowGroupColumns().length === 0
    },

    // Ag Grid sort method
    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function (s) {
          return s.sort != null
        })
        .map(function (s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      this.loading = true
      this.propertyUnitList = []
      if (sortData.length > 0) {
        this.defaultSortedBy = sortData[0]['colId']
        this.defaultSortOrder = sortData[0]['sort'] === 'asc'
      } else {
        this.defaultSortedBy = 'categoryCode'
        this.defaultSortOrder = true
      }
      this.getCategoryCodes(this.gridOptions, 'sort')
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    handleImport(event) {
      this.importClicked = true
      this.uploadedFile = event.file
      this.loadImport = true
    },

    beforeUpload(file) {
      const isValid =
        file.type === 'xlsx' ||
        file.type === 'xls' ||
        file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      if (!isValid) {
        showNotification('error', 'Import', 'Please upload excel file only!')
      }
      return isValid
    },

    updateTable() {
      this.importClicked = false
      this.refreshCategoryCodes()
    },

    clickedCancelimport(addedCount) {
      this.importClicked = false
      this.loadImport = false
      if (addedCount > 0) {
        this.refreshCategoryCodes()
      }
    },

    getWindowSize() {
      this.height = calculateGridHeight(
        'proprtyUnitTable',
        this.count > this.pageSize,
      )
    },

    onPagination(page) {
      this.loading = true
      this.page = page
      this.propertyUnitList = []
      this.selectedRowKeys = []
      this.getCategoryCodes(this.tableParams)
    },

    filterChanged() {
      this.filters = {}
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach((element, index) => {
        this.filters[element] = Object.values(data)[index]['filter']
      })
      this.loading = true
      this.page = 0
      this.propertyUnitList = []
      this.getCategoryCodes(this.gridOptions)
    },

    getBSUOP() {
      const url = dropdownAPIs.dropdown
      const method = 'post'
      const req = { bsuop: 0 }
      instance[method](url, req)
        .then(response => {
          this.bsuopList = []
          const list = _.get(response.data, 'result.bsuop', [])
          list.forEach(element => {
            element.value = `${element.option} - ${element.value}`
            element.option = element.value
            this.bsuopList.push(element)
          })
        })
        .catch(error => {
          errorService(error)
        })
    },

    getContract() {
      const url = dropdownAPIs.dropdown
      const method = 'post'
      const req = { contract: 0 }
      instance[method](url, req)
        .then(response => {
          this.contractList = []
          const list = _.get(response.data, 'result.contract', [])
          list.forEach(element => {
            element.contract = element.option
            element.contract_Name = element.value
            element.value = `${element.option} - ${element.value}`
            element.option = element.value
            this.contractList.push(element)
          })
        })
        .catch(error => {
          errorService(error)
        })
    },

    onContractChange(value) {
      const contract = this.contractList.find(i => i.value === value)
      if (contract) {
        this.form.contract_Details_Id = contract.id
      }
    },

    onChangeBSUOP(value) {
      const bsuop = this.bsuopList.find(i => i.value === value)
      if (bsuop) {
        this.form.BSUOP_Details_Id = bsuop.id
      }
    },

    onChangeAssetClass(value) {
      const assetClass = this.assetClassList.find(i => i.name === value)
      if (assetClass) {
        this.form.asset_Class_Id = assetClass.id
        this.form.asset_Class = assetClass.option
      }
    },

    onColumnResized(e) {
      if (e.finished) {
        this.updateColumnSettings()
      }
    },

    updateColumnSettings() {
      if (this.role === 'Admin') {
        this.tableState = this.gridOptions.columnApi.getColumnState()
        const request = {
          type: !this.type ? screenType.categoryCode : undefined,
          screenId: this.type ? this.screenId : undefined,
          tableName: this.type ? tableName.template.master.categoryCode : undefined,
          columnDetails: JSON.stringify(this.tableState),
        }
        if (!this.type) {
          this.$emit('updateColumns', request)
        } else {
          this.$emit('updateColumnSettings', request)
        }
      }
    },

    getColumnSettings(params) {
      if (this.type) {
        const columnDetails = this.columnSettings.find(
          i =>
            i.screenId === this.screenId &&
            i.tableName === tableName.template.master.categoryCode,
        )
        this.setColumnSettings(
          params,
          columnDetails ? columnDetails.columnDetails : null,
        )
        this.getCategoryCodes(this.gridOptions)
      } else {
        if (this.role === 'Admin') {
          instance
            .get(masterAPIs.columnSetting.get(screenType.categoryCode))
            .then(response => {
              const tableState = _.get(
                response.data,
                'result.columnDetails',
                null,
              )
              this.setColumnSettings(params, tableState)
            })
            .catch(error => {
              this.spinner = false
              errorService(error)
            })
        } else {
          this.setColumnSettings(params)
        }
        this.getCategoryCodes(this.gridOptions)
      }
    },

    setColumnSettings(params, tableState) {
      if (tableState && this.role === 'Admin') {
        this.tableState = JSON.parse(tableState)
        if (this.tableState.find(i => i.sort)) {
          this.defaultSortedBy = this.tableState.find(i => i.sort).colId
          this.defaultSortOrder =
            this.tableState.find(i => i.sort).sort === 'asc'
        }
        this.tableState[0].hide = !!this.type
        this.gridOptions.columnApi.applyColumnState({
          state: this.tableState,
        })
      } else {
        this.defaultSortedBy = 'categoryCode'
        this.defaultSortOrder = true
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: 'categoryCode',
              sort: 'asc',
            },
            {
              colId: 'action',
              hide: this.role !== 'Admin' || this.type === 'Template',
            },
            {
              colId: 'isActive',
              hide: this.role !== 'Admin' || this.type === 'Template',
            },
            {
              colId: '0',
              hide: this.role !== 'Admin' || this.type === 'Template',
            },
          ],
          defaultState: { sort: null },
        })
        params.api.sizeColumnsToFit()
      }
    },
  },
}
